import { createContext } from 'react';
const MakeContext = createContext();
export default MakeContext;
